import { gql, useQuery } from "@apollo/client";
import { generateCollapseFields } from "../utils/helpers/generateCollapseField";

interface UseDynamicQueryProps {
  parentQuery: string;
  childQuery: string;
  tableFields: any[];
  collapseFields: any[];
}

export const useDynamicQuery = ({
  parentQuery,
  childQuery,
  tableFields,
  collapseFields,
}: UseDynamicQueryProps) => {
  const queryName = `get${parentQuery.charAt(0).toUpperCase() + parentQuery.slice(1)}`;

  const QUERY = gql`
    query ${queryName} {
      ${parentQuery} {
        ${childQuery} {
          ${tableFields.map((field) => field.key).join("\n")}
          ${generateCollapseFields(collapseFields)}
        }
      }
    }
  `;

  const { error, loading, data } = useQuery(QUERY);

  return {
    error,
    loading,
    data: data ? data[parentQuery][childQuery] : [],
  };
};
